<template>

    <div class="container-pageAcceuil">
        <ChoixAppli @fisimedweb="lancerFisimedWeb" @fisimed="lancerFisimedClients" @altyse="lancerAltyseClients" @flic32="lancerFlic32" @TransCAM="lancerTransCAM"/>
    </div>
</template>
<style>
    .container-pageAcceuil{
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: center;
    }
</style>
<script>
    import { defineComponent } from 'vue';
    import ChoixAppli from './ChoixAppli.vue'
    import Connexion from '../script/Connexion.js'

    export default defineComponent({
        components: {
            //Les composants
            ChoixAppli
        },
        data: function () {
            return {
                message: 'Bienvenue dans PageChoixAppli !'
            }
        },

        computed: {

            appliLance() {
                return this.$store.getters.getAppliLance;
            },

            connexionValeur() {
                return this.$store.getters["ConnexionStore/getConnexionValeur"];
            }
        },
        created() {

            //On regarde si connecte
            if (!this.connexionValeur) {
                this.$router.push({name: "Accueil" })
            }
            //On cherche à savoir si une application a été lancé puis on la lance
            if (this.appliLance == "Fisimed") {
                this.$router.push({ name: "Fisimed" });
            }

            if (this.appliLance == "Altyse") {
                this.$router.push({ name: "Altyse" });
            }


            if (this.appliLance == "Flic32") {
                this.$router.push({name: "Flic32"})
            }
            if (this.appliLance == "TransCAM") {
                alert("On est ici !!");
                this.$router.push({ name: "TransCAM" })
            }
        },
        watch: {
            appliLance(value) {
                //alert("PageChoixAppli wathch appliLance" + value);
            }
        },

        methods: {
            // FISImed Web : autre application du portail, servie par sa propre instance. Le portail
            // remet un ticket a usage unique (30 s) que l'instance echange contre une session.
            async lancerFisimedWeb() {
                const r = await Connexion.ticketAppli("fisimed");
                const lien = r && r.BackEndLink && r.BackEndLink.trim();
                if (!r || !r.success || !r.Ticket || !lien) {
                    alert((r && r.resMsg) || "FISImed Web est indisponible pour ce compte.");
                    return;
                }
                window.location.assign(lien.replace(/\/+$/, "") + "/entree?ticket=" + encodeURIComponent(r.Ticket));
            },

            lancerFisimedClients() {
                /*this.fisimedClient = true;*/
                this.$store.dispatch("ConnexionStore/setAppliLance", { name: "Fisimed" });
                this.$store.dispatch("ConnexionStore/setAppliLaunched", true)
                this.$router.push({ name: "Fisimed" });
            },

            lancerAltyseClients() {
                this.$store.dispatch("ConnexionStore/setAppliLance", { name: "Altyse" });
                this.$store.dispatch("ConnexionStore/setAppliLaunched", true)
                this.$router.push({ name: "Altyse" });
            },

            lancerFlic32() {
                this.$store.dispatch("ConnexionStore/setAppliLance", { name: "Flic32" });
                this.$store.dispatch("ConnexionStore/setAppliLaunched", true)
                this.$router.push({name: "Flic32"})
            },
            lancerTransCAM() {
                this.$store.dispatch("ConnexionStore/setAppliLance", { name: "TransCAM" });
                this.$store.dispatch("ConnexionStore/setAppliLaunched", true)
                this.$router.push({ name: "TransCAM" })
            },
            appliLance() {
                return this.$store.getters["ConnexionStore/getAppliLance"];
            },

            deconnexion() {

            }

        },

        props: {

        }

    });
</script>
